module.exports = __webpack_public_path__ + "img/circle_arrow_right.054de034.svg";